<template>
  <div class="order_detail">
    <div class="order_head">
      <div class="order_head_title flex">
        <div class="page_title" style="width: 1%;margin-right: 30px;">
          <custom-breadcrumb :suffix="`Invoice NO. ${orderId}`"/>
        </div>
        <div class="page_button" >
          <!--          <el-button
                        v-if="orderStatus == 'Unpaid' || orderStatus == 'Failed'"
                        type="primary"
                        class="creat_button"
                        @click="openEditOrder()"
                        >Edit</el-button
                      >-->
          <el-button
            v-if="orderStatus == 'Unpaid' || orderStatus == 'Failed'"
            type="primary"
            class="creat_button orange_background"
            @click="toCopyInfo(orderId)"
          >Send Order Link
          </el-button
          >
          <el-button
            v-if="orderStatus == 'Unpaid' || orderStatus == 'Failed'"
            type="primary"
            class="creat_button"
            @click="changeOrderButton(orderId, 2, 'Cancel')"
          >Cancel
          </el-button
          >
          <el-button
            v-if="orderStatus == 'Paid'"
            type="primary"
            class="creat_button"
            @click="changeOrderButton(orderId, 40, 'Accept')"
          >Accept
          </el-button
          >
          <el-button
            v-if="brandShippingModel==='2' && orderStatus == 'Packaging' && (tsStoreOrderInfo['isProceedShipmented']!=null && tsStoreOrderInfo['isProceedShipmented']) "
            type="primary"
            class="creat_button"
            @click="gotoShipped"
          >Shipped
          </el-button
          >
          <el-button
            v-if="(orderStatus == 'Packaging' || orderStatus == 'Shipped' || orderStatus == 'Received' || orderStatus == 'Partial Shipped') "
            type="primary"
            class="creat_button"
            @click="gotoShippingInvoice"
          >Preview Invoice
          </el-button
          >

          <!-- 入驻和运营、并且为备货中显示以下仅退款按钮 begin-->
          <template v-if="(isOperationAccount || supplierManagementModelFlag) && (tsStoreOrderInfo.orderStatus == 40 || tsStoreOrderInfo.orderStatus == 4)">

            <el-button
              type="primary"
              v-if="tsStoreOrderInfo.orderStatus == 40 && tsStoreOrderInfo['type'] !==6 && tsStoreOrderInfo['type'] !==1 && !tsStoreOrderInfo['isRefuseFulfill'] && !tsStoreOrderInfo['isProceedShipmented']
               && (!tsStoreOrderInfo['isMarkNonwares'] || (tsStoreOrderInfo['isMarkNonwares'] && tsStoreOrderInfo['isNonwaresRetailerAgree']))
              && !tsStoreOrderInfo['isExistServiceOrder']"
              class="action_button action_button2"
              @click="$refs.outStackDialog.show(true,orderId)">
              Proceed the shipment
            </el-button>
            <el-button
              type="primary"
              v-if="tsStoreOrderInfo['isShowEditItem']"
              class="action_button action_button2"
              @click="$router.push({ path: 'edit-item-avaliability',query: {'orderId': orderId, 'userSource': $route.query.userSource} })"
            >
              Edit Item Availability
            </el-button>

            <el-button
              type="primary"
              v-if="tsStoreOrderInfo.orderStatus == 40 && tsStoreOrderInfo['type'] !==6 && tsStoreOrderInfo['type'] !==1 && !tsStoreOrderInfo['isRefuseFulfill'] && !tsStoreOrderInfo['isProceedShipmented'] && !tsStoreOrderInfo['isMarkNonwares'] && !tsStoreOrderInfo['isExistServiceOrder']"
              class="action_button action_button2"
              @click="$refs.outStackDialog.show(false,orderId)">
              Reject order
            </el-button>

          </template>
          <!-- 仅退款按钮end -->

          <el-button type="primary" v-if="isVidirect && supplierManagementModel!==2" style="width: 100px;height: 40px;background:#000000;color:#ffffff"
                     @click="invoice">
            Invoice
          </el-button>

        </div>
      </div>
      <div class="order_nav flex">
        <div class="nav_msg flex">
          <p class="nac_msg_name">Order total</p>
          <p class="nac_msg_num">{{ totalInfo.payAmount }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Orders Date</p>
          <p class="nac_msg_num">{{ orderDate }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Orders Status</p>
          <p class="nac_msg_num">{{ orderStatus }}</p>
        </div>
        <div class="nav_msg flex address_width">
          <!-- <p class="nac_msg_name">
            Ship To
            <template v-if="!finalStatus.includes(tsStoreOrderInfo['orderStatus'])">
              <span @click="openAddress"><img src="@/assets/img/memo.png" alt=""></span>
            </template>
          </p> -->
          <!-- vidirect用户显示地址，，或者非vidirect用户下的备货中显示地址 -->
            <!-- vidirect用户一定显示， 或者brandShippingModel=1平台发货(CN)  2自发货 -->
            <!-- <p class="nac_msg_num" style="padding-top: 0px"
             v-if="isVidirect || (tsStoreOrderInfo['orderStatus']!==0 && tsStoreOrderInfo['orderStatus']!==1 && tsStoreOrderInfo['orderStatus']!==2 && tsStoreOrderInfo['orderStatus']!==10 && tsStoreOrderInfo['orderStatus']!==11)">
            <template v-if="isVidirect || brandShippingModel==='2'">
              {{ tsStoreOrderAddress.name }}&nbsp;&nbsp;{{ tsStoreOrderAddress.lastname }}
              <br>
              {{ tsStoreOrderAddress.address }}&nbsp;
              <br>
              {{ tsStoreOrderAddress.city }}, {{ tsStoreOrderAddress.province }}, {{ tsStoreOrderAddress.countryName }}&nbsp;&nbsp;{{
                tsStoreOrderAddress.postCode
              }}
              <br>
              {{ tsStoreOrderAddress.areaCode }}-{{ tsStoreOrderAddress.phone }}
            </template>
            <template v-else>
              ShopVidi（收）
              <br>
              深圳市宝安区福海街道新和社区红牌工业园华丰智谷福海科技产业园A栋 A326-1
              <br>
              18038059068
            </template>

          </p>
          <p v-else>-</p> -->

        </div>
        <div class="nav_msg flex" style="width:20%">
          <p class="nac_msg_name no_border">Customer</p>
          <p class="nac_msg_num no_border">{{ customer }}</p>
        </div>
      </div>

      <p style="color: #FB541C;font-size: 14px;margin: 20px 20px;" v-if="tsStoreOrderInfo.orderStatus == 40">

        <!-- 缺货待retailer确认 -->
        <span v-if="tsStoreOrderInfo['isMarkNonwares'] && (tsStoreOrderInfo['isNonwaresRetailerAgree']==null)">
                The order has out of stock items, waiting for confirmation from the retailer
        </span>
        <!-- 缺货retailer确认 -->
        <span v-if="tsStoreOrderInfo['isMarkNonwares'] && (tsStoreOrderInfo['isNonwaresRetailerAgree'])">
            Confirmed by the retailer, please check that the remaining items are not out of stock and ship all at once
        </span>
        <!-- 缺货待retailer拒绝 -->
        <span v-if="tsStoreOrderInfo['isMarkNonwares'] && (tsStoreOrderInfo['isNonwaresRetailerAgree']!=null && !tsStoreOrderInfo['isNonwaresRetailerAgree'])">
                The retailer refuses to ship the remaining goods and has generated an after sale order
        </span>
        <!-- 整单拒绝 -->
        <span v-if="tsStoreOrderInfo['isRefuseFulfill']">The order was rejected by the brand:{{tsStoreOrderInfo['refuseFulfillReason']}}</span>

      </p>
    </div>
    <div class="order_tracking_information">
      <div v-if="orderLogisticsSelfDelivery && orderLogisticsSelfDelivery.id" class="order_tracking_information_header">
        <div class="order_tracking_information_header_action" @click="gotoTracking">Tracking info</div>
        <div class="order_tracking_information_header_action" @click="gotoShipped">Edit Tracking</div>
      </div>
      <!-- 分割线 -->
      <el-divider v-if="orderLogisticsSelfDelivery && orderLogisticsSelfDelivery.id"></el-divider>
      <div v-if="orderLogisticsSelfDelivery && orderLogisticsSelfDelivery.id" class="order_tracking_information_main">
        <div class="order_tracking_information_main_tracknumber">Tracking Number:<span>{{orderLogisticsSelfDelivery.logisticsNo}}</span></div>
        <div class="order_tracking_information_main_carrier">Shipping Carrier:<span>{{orderLogisticsSelfDelivery.shippingCarrierName}}</span></div>
        <div class="order_tracking_information_main_invoice" @click="viewInvoiceFile">Shipping invoice file</div>
      </div>
      <el-divider v-if="orderLogisticsSelfDelivery && orderLogisticsSelfDelivery.id"></el-divider>
      <div class="order_main">
        <el-table :data="skuList"  style="width: 100%">
          <el-table-column prop="date" label="Item" width="420">
            <template slot-scope="scope">
              <div class="prduct_box">
                <img class="product_img" :src="scope.row.skuImg" alt=""/>
                <div class="product_info">
                  <p class="product_name">
                    {{ scope.row.skuName }}
                  </p>
                  <p class="product_size">
                    {{ scope.row['finalSkuName'] }}
                    <span style="color: #8F8F8F;margin-left: 15px;font-size: 14px;"> {{ scope.row['skuCode'] }}</span>
                  </p>

                  <!-- 缺货 -->
                  <div class="mark-error" style="height: 40px;" v-if="scope.row['skuStatus']=='0' && (tsStoreOrderInfo['isMarkNonwares'] || tsStoreOrderInfo['isRefuseFulfill'])">
                    This item is temporarily out of stock, {{scope.row['serviceOrderWaitNum']}} items can be shipped
                    <span style="margin-left: 5px;">Restock Date: {{scope.row['skuRestockDate']}}</span>
                  </div>
                  <!--下架 -->
                  <div class="mark-error" v-if="scope.row['skuStatus']=='2' && (tsStoreOrderInfo['isMarkNonwares'] || tsStoreOrderInfo['isRefuseFulfill'])">
                    This item is sold out，{{scope.row['serviceOrderWaitNum']}} items can be shipped
                  </div>

                </div>
              </div>

            </template>
          </el-table-column>


          <!-- 自营模式：订单详情只显示成本价，可修改订单商品品牌优惠 add by cpgu 2024/05/30 -->
          <el-table-column label="Cost Price" width="150" v-if="supplierManagementModel===2">
            <template slot-scope="scope">
              <div class="prduct_box flex">

                <span>{{ scope.row['sourcePrice'] | fixed2 }}</span>

              </div>
            </template>
          </el-table-column>


          <!-- 入驻模式：订单详情只显示批发价，去掉离岸价 add by cpgu 2024/05/30 -->
          <el-table-column label="FOB Price" width="150" v-if="!supplierManagementModelFlag && supplierManagementModel!=2">
            <template slot-scope="scope">
              <div class="prduct_box flex">
                <!-- 订单状态为未付款、付款失败才可以编辑 -->
                <el-input
                  v-if="(orderStatus == 'Unpaid' || orderStatus == 'Failed')  && (tsStoreOrderInfo['type'] !==7) "
                  class="price_input"
                  @change="(event)=>blurFob(event,scope.$index,scope['row'])"
                  v-model="scope.row['fobPriceFinal']"
                  placeholder="FOB Price"
                  oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                />
                <span v-else>{{ scope.row['fobPriceFinal'] | fixed2 }}</span>
                <div v-if="scope.row['fobPriceFinalBefore'] !=scope.row['fobPriceFinal']"
                    :class="scope.row['fobPriceFinalBefore'] !=scope.row['fobPriceFinal'] ?'dis_price dis_line':'dis_price'">
                  ${{ scope.row['fobPriceFinalBefore'] }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Wholesale Price" width="150" v-if="supplierManagementModel!=2">
            <template slot-scope="scope">
              <div class="prduct_box flex">
                {{ scope.row.unitPrice | fixed2 }}
                <div v-if="scope.row['unitPrice'] !=scope.row['unitPriceBeforeDiscount']"
                    :class="scope.row['unitPrice'] !=scope.row['unitPriceBeforeDiscount'] ?'dis_price dis_line':'dis_price'">
                  ${{ scope.row['unitPriceBeforeDiscount'] }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Qty" width="100">
            <template slot-scope="scope">
              <div class="prduct_box flex qty-left">
                <!-- 不修改数量，不然会触发重新计算物流费，有问题 先注释掉以下 2023/03/21 cpgu -->
                <!-- 订单状态为(未付款 || 付款失败) && (BD || operation)  才可以编辑 -->
  <!--              <el-input
                  v-if="(orderStatus == 'Unpaid' || orderStatus == 'Failed') && (isBd || isOperationAccount)"
                  class="price_input"
                  oninput="if(value){value=value.replace(/[^\d]/g,'')}  if(value<1){value=1}"
                  v-model="scope.row.num"
                  @change="(e)=>changeNum(e,scope.$index,scope['row'])"
                  placeholder="Qty"
                />-->

                <span>{{ Number(scope.row['num']) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Total">
            <template slot-scope="scope">
              <div class="flex total_amount">
                <!-- 自营模式total=costPrice*Num -->
                <span v-if="supplierManagementModel===2">${{ (Number(scope.row['sourcePrice']) * Number(scope.row['num'])) | fixed2 }}</span>
                <span v-else>${{ (Number( !scope.row['isSkuChangePrice']?scope.row['unitPrice']:scope.row['unitPriceBeforeDiscount']) * Number(scope.row['num'])) | fixed2 }}</span>
                <!-- 不能删除OI，不然会触发重新计算物流费先注释掉以下 2023/03/21 cpgu -->
                <!-- 订单状态为(未付款 || 付款失败) && (BD || operation)  才可以删除 -->
  <!--              <span v-if="(orderStatus == 'Unpaid' || orderStatus == 'Failed') && (isBd || isOperationAccount) "
                      class="order-delete" @click="deleteOrder(scope.row)"><i class="el-icon-close"></i></span>-->
              </div>
            </template>
          </el-table-column>

          <!-- 订单状态为未付款、付款失败不显示状态 -->
          <el-table-column label="Item Status" v-if="orderStatus !== 'Unpaid' && orderStatus !== 'Failed'">
            <template slot-scope="scope">
              <span v-if="!scope.row['serviceOrderStatus'] || scope.row['serviceOrderStatus']==1">{{ scope.row.orderStatus | skuStatusFilter }}</span>
              <span style="color:#FF4812;text-decoration: underline;cursor: pointer" v-else
                    @click="gotoServiceOrders(scope.row.uid)">
  <!--                  {{scope.row.orderServiceDetailStatus | serviceStatusFilter}}-->
                      {{ scope.row['serviceOrderStatus'] == 2 ? 'In-Service' : 'Refunded' }}
                  </span>

            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
    <div class="order_footer">
      <div class="footer_title">
        Payment method <span class="footer_subtitle">{{ paymentMethod }}</span>
        <div class="memo">
          Memo
          <img src="@/assets/img/memo.png" alt="" @click="editMemo">
          <span>{{ tsStoreOrderInfo.memo }}</span>
        </div>
      </div>
      <div class="end_box flex">
        <div class="creat_text flex">
          <p>{{ tsStoreOrderInfo['brandName'] }}</p>
          <p v-if="supplierManagementModel!==2">${{ totalInfo['cifSubTotal'] | fixed2 }}</p>
          <p v-else>${{ totalInfo['sourcePriceTotal'] | fixed2 }}</p>
        </div>
        <div class="creat_text flex" v-if="supplierManagementModel!==2">
          <p></p>
          <p style="color: #5D5D5D;">(FOB Subtotal ${{ totalInfo['fobSubtotal'] | fixed2 }})</p>
        </div>
        <!--            <div class="creat_text flex">
                        <p>Total quantity</p>
                        <p>{{totalQuantity}}</p>
                    </div>
                    <div class="creat_text flex">
                        <p>Total price of goods</p>
                        <p>${{totalPriceBefore}}</p>
                    </div>-->
        <div class="creat_text flex" v-if="supplierManagementModel!==2">
          <p class="brown_text">Product discount</p>
          <p class="brown_text">
            <span class="black_text">-</span>${{ totalInfo['totalPriceProductDicounted'] | fixed2 }}
          </p>
        </div>
        <div class="creat_text flex">
          <p class="brown_text">Bulk order discount</p>
          <p class="brown_text">
            <span class="black_text">-$</span>
            <el-input
              v-if="orderStatus == 'Unpaid' || orderStatus == 'Failed'"
              class="price_input brown_text"
              oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
              v-model="totalInfo['totalPriceOrderDiscounted']"
              placeholder=""
              clearable
              @change="changePrice"
            />
            <span v-else>{{ totalInfo['totalPriceOrderDiscounted'] }}</span>
          </p>
        </div>

        <div class="creat_text flex" v-if="totalInfo['totalPriceOrderDiscountedShopvidi']">
          <p class="brown_text">Offered by ShopVidi</p>
          <p class="brown_text">
            <span class="black_text">-$</span>
            <!--              <template v-if="isOperationAccount">
                            <el-input
                              style="height: 35px;"
                              class="price_input brown_text"
                              oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                              v-model="totalInfo['totalPriceOrderDiscountedShopvidi']"
                              placeholder=""
                              clearable
                              @change="changeShopvidiPrice"
                            />
                          </template>
                          <template v-else>
                            {{ totalInfo['totalPriceOrderDiscountedShopvidi'] | fixed2 }}
                          </template>-->
            {{ totalInfo['totalPriceOrderDiscountedShopvidi'] | fixed2 }}
          </p>
        </div>

        <!-- <div class="creat_text flex">
            <p>Shipping</p>
            <p>${{totalFreightPriceBefore}}</p>
        </div> -->
        <!--            <div class="creat_text flex">
                        <p class="brown_text">Shipping fee</p>
                        <p class="brown_text">
                        <span class="black_text"></span>${{totalFreight}}
                        </p>
                    </div>-->
        <div class="creat_text flex">
          <div class="split"></div>
        </div>

        <div class="creat_text flex" style="font-weight: 600;">
          <p>Subtotal</p>
          <p>${{ totalInfo['subTotal'] | fixed2 }}</p>
        </div>
        <div class="creat_text flex">
          <p>Shipping</p>
          <p>+${{ totalInfo['totalFreightBefore'] }}</p>
        </div>
        <div class="creat_text flex">
          <!-- 为首单或者平台发货+首单，则显示shopvidi -->
          <p>Shipping Disc (By
            {{
              this.tsStoreOrderInfo['logisticUnderwriter'] || (brandShippingModel === '1') ? 'ShopVidi' : 'Brand'
            }})</p>
          <!-- 订单状态为待付款或失败；-->
          <!-- 非vilocal订单：并且品牌不包邮;非首单;  并且 (入驻模式、订单物流优惠承担方为品牌 | 订单物流优惠承担方为平台、运营者) -->
          <!-- vilocal订单：运营账号可以修改；并且品牌不包邮;非首单;  并且 (入驻模式、订单物流优惠承担方为品牌 | 订单物流优惠承担方为平台、运营者)  -->
          <p v-if="(orderStatus == 'Unpaid' || orderStatus == 'Failed')
                        && ((
                          this.tsStoreOrderInfo['type']!==7
                          && !isShippingFree
                          && !this.tsStoreOrderInfo['logisticUnderwriter']
                          && ( (this.supplierManagementModelFlag && this.brandShippingModel==='2') || (isOperationAccount&&this.brandShippingModel==='1') ))
                          )
                        ||(
                          this.tsStoreOrderInfo['type'] ===7
                          && (isOperationAccount || ((!isShippingFree && !this.tsStoreOrderInfo['logisticUnderwriter'])
                              && ( (this.supplierManagementModelFlag && this.brandShippingModel==='2') || (isOperationAccount&&this.brandShippingModel==='1') ))
                            )
                          )
                        ">
            <span class="black_text">-$</span>
            <el-input
              class="price_input brown_text"
              :disabled="disabled"
              oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
              v-model="totalInfo['totalFreightDiscounted']"
              placeholder=""
              @change="changeTotalFreight"
            />
          </p>
          <p v-else>
            -${{ totalInfo['totalFreightDiscounted'] }}
          </p>
        </div>
        <div class="creat_text flex">
          <div class="split"></div>
        </div>

        <div class="creat_text blod_text flex">
          <p>Total Amount</p>
          <p class="amount_text">${{ totalInfo['payAmount'] | fixed2 }}</p>
        </div>
        <el-button v-if="orderStatus == 'Unpaid' || orderStatus == 'Failed'" type="primary" class="add-btn"
                   @click="editOrder()">Submit
        </el-button>
      </div>
      <div>
        <Address ref="address" :addressMessage="addressMessage"/>
      </div>
    </div>
    <edit-memo :message="tsStoreOrderInfo" ref="memo"></edit-memo>
    <el-dialog
      :visible.sync="acceptVisible"
      width="30%"
      @close="acceptVisible = false"
    >
      <span class="back_icon"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text" v-if="changeOrderNum == 40">
        Please review the Item availability before shipping orders
      </p>
      <p class="success_text" v-if="changeOrderNum == 2">
        Are you sure you want to cancel the order?
      </p>
      <p class="success_text" v-if="changeOrderNum == 5">
        Please confirm that your order has been shipped
      </p>
      <span slot="footer" class="dialog-footer flex_all">
        <el-button @click="acceptVisible = false">Cancel</el-button>
        <el-button type="primary" class="confirm_button" @click="confirmOrderStatus()"
        >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="copyVisible"
      width="30%"
      @close="copyVisible = false;copyEdit = false"
    >
      <span class="back_icon"
      ><i class="el-icon-arrow-left"></i>Send Order Link</span
      >
      <div class="border_box">
        <p class="copy_title">your order link</p>
        <p class="copy_subtitle">
          https://www.shopvidi.com/whosalesDetails/{{ rowOrderID }}
        </p>
        <p class="copy_title">ShopVidi Account</p>
        <p class="copy_subtitle">{{ nowretailerName }}</p>
      </div>
      <div class="flex_all">
        <el-button type="primary" class="back_button" @click="copyLink($event)"
        ><i class="el-icon-paperclip"></i>{{ copyEdit ? 'Copied' : 'Copy' }}
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="successVisible"
      :close-on-click-modal="false"
      width="30%"
      @close="backOrderList()"
    >
      <span class="back_icon" @click="backOrderList()"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text">Order modified successfully</p>
      <div class="flex_all">
        <el-button
          type="primary"
          class="back_button"
          @click="backOrderList()"
        >Back Order List ({{ seconds }})
        </el-button
        >
      </div>
    </el-dialog>
    <!-- 缺货弹框 -->
    <out-stock ref="outStackDialog"></out-stock>
  </div>
</template>

<script>
import {getAction, postAction, putAction} from '@/api/manage.js'
import {formateDate} from '@/components/formateEnDate.js'
import editMemo from '@/pages/components/edit-memo.vue'
import Address from '@/pages/components/address.vue'
import {handleClipboard} from '@/utils/copy'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import OutStock from './out-stock-confirm-dialog'
import {orderStatusDis, serviceOrderStatusDis} from '../../utils/status'

export default {
  components: {OutStock, editMemo, Address, CustomBreadcrumb},
  data() {
    return {
      isBd: false,
      changeOrderId: '',
      changeOrderNum: '',
      acceptVisible: false,
      rowOrderID: '',
      copyVisible: false,
      orderLink: '',
      nowretailerName: '',
      copyEdit: false,
      successVisible: false,
      timer: '',
      seconds: 5,
      icon1: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-d-1.png',
      icon2: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-d-2.png',
      orderId: '',
      brandShippingModel: '',
      paymentMethod: '', // 支付方式
      userInfo: '', // 收货人信息和手机号
      address: '', // 上方的shipto
      orderStatus: '', // 订单状态
      orderDate: 'Jan,1,1970', // 订单时间
      customer: '', // customer信息
      skuList: [], // sku信息
      iconFlag: false, // 标识显示哪张图片,
      isVidirect: false, // 是否为vidirect用户
      isOperationAccount: false, // 是否为运营账号
      disabled: false,
      supplierManagementModelFlag: true, // 判断是入住还是自营 true：入驻
      supplierManagementModel: 1, // 判断是入住还是自营 true：入驻
      isShippingFree: false, // 品牌是否免邮
      tsStoreOrderInfo: {}, // tsStoreOrderInfo memo
      addressMessage: {}, // 地址信息
      tsStoreOrderAddress: {}, // 接口地址赋值
      removeOrderDetailIds: [],
      // 订单终态2已取消 3已发货 4部分发货 5已收货 6退款审核中 7已退款 8拒绝退款 9部分退款 13退货中 42终止发货 44,45,56确认发货 52部分送达 53已送达 57超时未收货 99交易关闭
      finalStatus: [2, 3, 4, 5, 6, 7, 8, 9, 13, 42, 44, 45, 46, 52, 53, 57, 99],
      shippingPrice: 0, // 订单估算物流费
      totalInfo: {
        fobSubtotal: 0, // 订单离岸价
        cifSubTotal: 0, // 订单原始到岸价
        sourcePriceTotal: 0, // 订单总成本价
        totalQuantity: 0, // 该订单下了多少个件商品
        totalPriceBefore: 0, // 该订单的优惠前金额
        totalPriceProductDicounted: 0, // 该订单商品优惠的金额
        totalPriceOrderDiscounted: 0, // 该订单  订单优惠金额
        totalPriceOrderDiscountedShopvidi: 0, // 该订单shopvidi优惠金额[优惠券]
        totalPrice: 0, // 该订单优惠后金额
        totalFreightBefore: 0, // 该订单物流 优惠前金额
        totalFreightDiscounted: 0, // 该订单物流优惠金额
        totalFreight: 0, // 物流实际费用
        subTotal: 0,
        payAmount: 0 // 订单实付金额
      },
      orderLogisticsSelfDelivery: null
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    // 1平台发货(CN)  2自发货
    // this.brandShippingModel = this.$route.query.brandShippingModel
    this.isVidirect = this.$route.query.userSource === '1'

    this.loadRole()
    // notes 获取orderID
    this.loadOrderDetails()
    this.loadBrandInfo()
  },
  filters: {
    skuStatusFilter(f) {
      return orderStatusDis(f)
    },
    serviceStatusFilter(f) {
      return serviceOrderStatusDis(f)
    },
    fixed2: (v) => {
      let num = parseFloat(v), digit = 2
      return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
    }
  },
  methods: {
    gotoShippingInvoice() {
      // 跳转发货单页面
      this.$router.push({
        path: 'shipping-invoice',
        query: {'orderId': this.orderId, 'brandShippingModel': this.$route.query.brandShippingModel, 'userSource': this.$route.query.userSource}
      })
    },
    viewInvoiceFile() {
      window.open(this.orderLogisticsSelfDelivery.shippingInvoiceFile)
    },
    gotoShipped() {
      this.$router.push({
        path: 'shipping',
        query: {'orderId': this.orderId, 'brandShippingModel': this.$route.query.brandShippingModel, 'userSource': this.$route.query.userSource}
      })
    },
    gotoTracking() {
      window.open('https://t.17track.net/en#nums=' + this.orderLogisticsSelfDelivery.logisticsNo)
    },
    gotoServiceOrders(orderDetailId) {
      this.$router.push({path: 'service-order', query: {orderDetailId: orderDetailId}})
    },
    loadBrandInfo() {
      // 此处不调用后端了，采用前端的方式来处理，判断localStorage
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      // 如果是运营账号
      /* if (userInfo.model === '4') {
        this.operate = true
      } */
      /**
       * 2023/07/10 自营和入驻不再做功能上的判断
       * 2024/05/30 订单详情只显示批发价，去掉离岸价
       */
      if (userInfo.supplierManagementModel === 1) {
        this.supplierManagementModelFlag = true
      } else {
        this.supplierManagementModelFlag = false
      }
      this.supplierManagementModel = userInfo.supplierManagementModel
    },
    async loadRole() {
      let roleData = await getAction(`/sp/suppliers/own-brand`)
      this.isOperationAccount = roleData['result']['model'] === '4'
      this.isBd = roleData['result']['id'] === '1525746010330509314'
      // notes SV-1.4.19 新增处理物流费的编辑权限

      // modify by cpgu 经过确认，以下功能属于过期功能，可以注释掉 2022/12/22
      // 2023/03/21经过贾蓉确认放开以下   cpgu
      /**
       * 1、首单除了运营外都不能编辑
       * 2、除BD和运营外不能编辑
       */
      // notes 首单除了运营都不能 编辑
      if (this.tsStoreOrderInfo.logisticUnderwriter && !this.isOperationAccount) {
        this.disabled = true
      }
      if (!this.isBd && !this.isOperationAccount) {
        this.disabled = true
      }
      // end by cpgu
    },
    openEditOrder() {
      this.$router.push({path: 'editOrder', query: {orderId: this.orderId}})
    },
    changeOrderButton(orderId, newOrderStatus, button) {
      this.changeOrderId = orderId
      this.changeOrderNum = newOrderStatus
      this.acceptVisible = true
      if (button == 'Cancel') {
        this.CancelEdit = true
        this.ShippedEdit = false
        this.AcceptEdit = false
      } else if (button == 'Accept') {
        this.CancelEdit = false
        this.ShippedEdit = false
        this.AcceptEdit = true
      } else if (button == 'Shipped') {
        this.CancelEdit = false
        this.ShippedEdit = true
        this.AcceptEdit = false
      }
    },
    confirmOrderStatus() {
      this.acceptVisible = false
      this.changeOrderStatus(this.changeOrderId, this.changeOrderNum)
    },
    changeOrderStatus(id, status) {
      putAction(
        '/sp/suppliers/retailers/orders/' + id + '/' + status
      ).then((res) => {
        if (res.success) {
          this.loadOrderDetails()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    toCopyInfo(orderid) {
      this.copyVisible = true
      this.rowOrderID = orderid
      this.orderLink = 'your order link : https://www.shopvidi.com/whosalesDetails/' + orderid + '\r\n' + 'shopvidi Account : ' + this.tsStoreOrderInfo.updateBy
      this.nowretailerName = this.tsStoreOrderInfo.updateBy
    },
    invoice() {
      this.$router.push({
        path: `invoice?orderId=${this.$route.query.orderId}&orderType=true`
      })
      // this.$router.push({ path: 'Order' })
    },
    openAddress() {
      this.addressMessage = {
        addressId: this.tsStoreOrderAddress.addressId,
        userId: this.tsStoreOrderAddress.createBy,
        type: 'ordeDetail'
      }
      this.$refs.address.dialogVisible = true
    },
    editMemo() {
      this.$refs.memo.dialogVisible = true
    },
    loadOrderDetails() {
      if (this.orderId === '') {
        this.$message.warning('No Order')
        return
      }
      getAction('/order/api/v0.2/brand/orders/' + this.orderId + '/details').then(response => {
        if (response.success) {
          if (response.result) {
            this.handlePayMethod(response.result.paymentMethod)
            this.handlePrice(response.result.tsStoreOrderInfo)
            this.handleAddress(response.result.tsStoreOrderAddress)
            this.handleCustomer(response.result.customer)
            this.skuList = response.result.skuItemsList
            this.tsStoreOrderInfo = response.result.tsStoreOrderInfo
            this.tsStoreOrderAddress = response.result.tsStoreOrderAddress
            this.orderLogisticsSelfDelivery = response.result.orderLogisticsSelfDelivery
            this.brandShippingModel = response.result.brandShippingModel + ''

            // add by cpgu 初始化计算fob\cif\subtotal，此行代码要放在赋值skuList之后 begin
            this.buildFobWithCif()
            // ============== begin brand直接订单修改的价，兼容retailer 2023/03/28 =========
            let diffCifTotal = 0
            let diffFobTotal = 0
            let sourcePriceTotal = 0
            this.skuList.map((e, i) => {
              // 把数据库isSkuChangePrice赋值给一个临时变量，给后面提交重新赋值使用
              e['db_isSkuChangePrice'] = e['isSkuChangePrice']
              if (!e['isSkuChangePrice']) {
                diffCifTotal += (e['unitPriceBeforeDiscount'] - e['unitPrice']) * e['num']
                diffFobTotal += (e['fobPriceFinal'] - e['unitPrice']) * e['num']
              //  e['fobPriceFinal'] = e['unitPrice']
              }
              sourcePriceTotal += Number(e['sourcePrice']) * e['num']
            })
            this.totalInfo['sourcePriceTotal'] = sourcePriceTotal
            this.totalInfo['cifSubTotal'] = (this.totalInfo['cifSubTotal'] - diffCifTotal)
            // this.totalInfo['fobSubtotal'] = (this.totalInfo['fobSubtotal'] - diffFobTotal)
            if (diffCifTotal > 0) {
              this.totalInfo['cifSubTotal'] += Number(this.totalInfo['totalPriceProductDicounted'])
            }
            // ==============end brand直接订单修改的价，兼容retailer=========

            // subTotal
            this.totalInfo['subTotal'] = Number(this.totalInfo['cifSubTotal']) - Number(this.totalInfo['totalPriceProductDicounted']) - Number(this.totalInfo['totalPriceOrderDiscounted']) - Number(this.totalInfo['totalPriceOrderDiscountedShopvidi'])

            // 如果为自营账号
            if (this.supplierManagementModel === 2) {
              if (this.tsStoreOrderInfo['type'] === 7) {
                this.totalInfo['totalPriceOrderDiscounted'] = this.totalInfo['sourcePriceTotal']
              } else {
                // 自营账号不显示平台折扣[优惠券]
                this.totalInfo['totalPriceOrderDiscountedShopvidi'] = null
              }



              this.totalInfo['subTotal'] = Number(this.totalInfo['sourcePriceTotal']) - Number(this.totalInfo['totalPriceProductDicounted']) - Number(this.totalInfo['totalPriceOrderDiscounted']) - Number(this.totalInfo['totalPriceOrderDiscountedShopvidi'])
              this.totalInfo['payAmount'] = Number(this.totalInfo['subTotal']) + Number(this.totalInfo['totalFreightBefore']) - Number(this.totalInfo.totalFreightDiscounted)
            }
            // end by cpgu

            getAction(`/tsCollectionBrand/queryById?id=${this.tsStoreOrderInfo['brandId']}`).then(res => {
              this.isShippingFree = res.result['shippingFree'] == '1'
            })
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleCustomer(customer) {
      if (customer === null || JSON.stringify(customer) === '{}') {
        return
      }
      if (customer.userName) {
        this.customer = customer.userName + '(Level  ' + customer.level + ')'
      }
    },
    handleAddress(addressInfo) {
      if (JSON.stringify(addressInfo) === '{}') {
        return
      }
      this.userInfo = addressInfo.name + '  ' + addressInfo.lastname + '   ' + addressInfo.areaCode + '-' + addressInfo.phone
      this.address = '【' + addressInfo.countryName + '】' + addressInfo.province + ' , ' + addressInfo.city + ' , ' + addressInfo.postCode + ' , ' + addressInfo.address
    },
    handlePrice(orderInfo) {
      if (JSON.stringify(orderInfo) === '{}') {
        return
      }
      /**
       * Product discount ：   productDiscounted
       * Bulk order discount： orderDiscounted
       * Offered by ShopVidi：couponPrice
       * Shipping Fee (By Brand)：totalFreight
       * Total Amount  ：payAmount
       */
      /* if (orderInfo.totalPriceBefore) {
        this.totalPriceBefore = Number(orderInfo.totalPriceBefore).toFixed(2)
      } */
      if (orderInfo.productDiscounted) {
        this.totalInfo.totalPriceProductDicounted = Number(orderInfo.productDiscounted).toFixed(2)
      }
      if (orderInfo.orderDiscounted) {
        this.totalInfo.totalPriceOrderDiscounted = Number(orderInfo.orderDiscounted).toFixed(2)
      }
      if (orderInfo.couponPrice) {
        this.totalInfo.totalPriceOrderDiscountedShopvidi = Number(orderInfo.couponPrice).toFixed(2)
      }
      if (orderInfo.payAmount) {
        this.totalInfo.payAmount = Number(orderInfo.payAmount).toFixed(2)
      }

      // 物流试算
      if (orderInfo.totalFreightBefore) {
        this.totalInfo.totalFreightBefore = Number(orderInfo.totalFreightBefore).toFixed(2)
      }
      // 物流折扣
      if (orderInfo.freightDiscounted) {
        this.totalInfo.totalFreightDiscounted = Number(orderInfo.freightDiscounted).toFixed(2)
      }
      if (orderInfo.totalFreight) {
        this.totalInfo.totalFreight = Number(orderInfo.totalFreight).toFixed(2)
      }

      // 兼容历史数据（物流试算为空，物流折扣为负数）
      if (!orderInfo.totalFreightBefore && orderInfo.freightDiscounted && Number(orderInfo.freightDiscounted) < 0) {
        this.totalInfo.totalFreightBefore = Math.abs(Number(orderInfo.freightDiscounted)).toFixed(2)
        this.totalInfo.totalFreightDiscounted = '0.00'
      }

      if (orderInfo.goodsNum) {
        this.totalQuantity = orderInfo.goodsNum
      }
      if (orderInfo.orderStatus !== null) {
        this.orderStatus = this.handleOrderStatus(orderInfo.orderStatus, true)
      }
      if (orderInfo.createAt) {
        this.orderDate = formateDate(orderInfo.createAt)
      }
    },
    handlePayMethod(paymentMethod) {
      if (paymentMethod) {
        if (paymentMethod === 1) {
          this.paymentMethod = 'Net 60 Payment Terms'
        } else if (paymentMethod === 2 || paymentMethod === 4) {
          this.paymentMethod = 'Pay With Card'
        } else if (paymentMethod === 3) {
          this.paymentMethod = 'Pay With ACH'
        } else if (paymentMethod === 5) {
          this.paymentMethod = 'Pay With PayPal'
        }
      }
    },
    copyLink(e) {
      this.copyEdit = !this.copyEdit
      handleClipboard(this.orderLink, e)
    },
    handleOrderStatus(t, flag) {
      if (flag && [3, 4, 5, 24, 52, 53, 54].includes(t)) {
        this.iconFlag = true
      }
      return orderStatusDis(t)
    },
    toOrders() {
      this.$router.push({path: '/menu/Order'})
    },
    changePrice(value) {
      if (Number(value) > (Number(this.totalInfo.cifSubTotal) - Number(this.totalInfo.totalPriceProductDicounted)).toFixed(2)) {
        this.totalInfo.totalPriceOrderDiscounted = 0
      } else {
        this.totalInfo.totalPriceOrderDiscounted = !value ? 0 : value
      }
      this.builderTotalInfo()
    },
    changeShopvidiPrice(value) {
      if (Number(value) > (Number(this.totalInfo.cifSubTotal) - Number(this.totalInfo.totalPriceProductDicounted)).toFixed(2)) {
        this.totalInfo.totalPriceOrderDiscountedShopvidi = 0
      } else {
        this.totalInfo.totalPriceOrderDiscountedShopvidi = value
      }
      this.builderTotalInfo()
    },
    changeTotalFreight(v) {
      v = v || 0
      if (Number(v) > Number(this.totalInfo['totalFreightBefore'])) {
        v = 0
      }
      if (!v) {
        this.$message.error('Incorrect format')
      }
      this.totalInfo['totalFreightDiscounted'] = v
      this.totalInfo['payAmount'] = Number(this.totalInfo['subTotal']) + Number(this.totalInfo['totalFreightBefore']) - Number(v)

      // 修改使用
      this.tsStoreOrderInfo['freightDiscounted'] = this.totalInfo.totalFreightDiscounted
      this.tsStoreOrderInfo['totalFreight'] = Number(this.totalInfo.totalFreightBefore) - Number(this.totalInfo.totalFreightDiscounted)
      this.tsStoreOrderInfo['payAmount'] = this.totalInfo.payAmount
    },

    deleteOrder(data) {
      if (this.skuList.length == 1) {
        this.$message.warning('There is only 1 item in the order and cannot be deleted')
        return
      }

      this.skuList.map((e, i) => {
        if (e['skuCode'] === data['skuCode']) {
          this.removeOrderDetailIds.push(e.uid)
          this.skuList.splice(i, 1)
        }
      })

      this.builderTotalInfo()
    },
    blurFob(event, index, row) {
      // let value = event.target.value
      let value = Number(event)
      if (value) {
        if (value > Number(row['fobPriceFinalBefore'])) {
          this.$set(this.skuList[index], 'fobPriceFinal', row['fobPriceFinalBefore'].toFixed(2))
          this.$message.warning("Discount price should't larger than original Price")
          return
        }

        // CIF = FOB+履约服务费
        let servicePrice = (row['serviceCharge'] / row['num'])
        this.$set(this.skuList[index], 'unitPrice', (value + servicePrice).toFixed(2))
      } else {
        this.$set(this.skuList[index], 'fobPriceFinal', row['fobPriceFinalBefore'].toFixed(2))
        this.$set(this.skuList[index], 'unitPrice', row['unitPriceBeforeDiscount'].toFixed(2))
      }

      // 如果修改了商品价格、数量，则品牌优惠、物流优惠要清0
      this.totalInfo['totalPriceOrderDiscounted'] = 0
      this.totalInfo['totalFreightDiscounted'] = 0

      // 修改了商品价格，则isSkuChangePrice更改为0，表示非brand端商品详情修改
      this.$set(this.skuList[index], 'isSkuChangePrice', 0)
      this.$set(this.skuList[index], 'currentChangePrice', true)

      this.builderTotalInfo()
    },
    buildShippingPrice() {
      let freightParams = this.skuList.map(sku => {
        return {
          skuId: sku['skuId'],
          goodsId: sku['goodsId'],
          weight: sku['weight'],
          num: sku['num'],
          isFreeShipping: this.isShippingFree
        }
      })

      postAction('/sp/suppliers/retailers/orders/freight', freightParams).then((res) => {
        if (res.success) {
          this.totalInfo.totalFreightBefore = Number(res.result)
          this.totalInfo.totalFreight = Number(res.result) - Number(this.totalInfo.freightDiscounted ? this.totalInfo.freightDiscounted : 0)
          this.builderTotalInfo()
          console.log('已计算运费', this.shippingPrice)
        }
      })
    },
    changeNum(e, index, row) {
      let value = Number(e)
      if (value) {
        // commodityAmount=原始到岸价*数量
        this.$set(this.skuList[index], 'commodityAmount', (value * row['unitPriceBeforeDiscount']).toFixed(2))

        // 如果修改了数量，则物流费重置、优惠（品牌优惠）清0
        this.totalInfo['totalPriceOrderDiscounted'] = 0
        this.totalInfo['totalFreight'] = 0

        this.buildShippingPrice()
      }
    },
    buildFobWithCif() {
      this.totalInfo.fobSubtotal = 0
      this.totalInfo.cifSubTotal = 0
      this.skuList.map((e, i) => {
        this.totalInfo.fobSubtotal += (Number(e['fobPriceFinal']) * Number(e['num']))
        this.totalInfo.cifSubTotal += (Number(e['unitPriceBeforeDiscount']) * Number(e['num']))
      })
    },
    builderTotalInfo() {
      this.buildFobWithCif()
      this.totalInfo.totalPriceProductDicounted = 0
      let goodsNum = 0
      this.skuList.map((e, i) => {
        // （add by cpgu 2023/03/21）
        // 重新计算OI价
        e['commodityAmount'] = Number(e['unitPrice']) * Number(e['num'])
        // 注释以下两个，因为放开后，所有的价格（brand\retailer都错了。）故需要注释，在retailer点击update时修改。
        // 设置新价和SKU价一样，避免用户retail 待下单点击update，同时更改订单中其他OI价格时，避免出错。
        // e['newUnitPrice'] = Number(e['unitPrice'])
        // 设置折扣之前价和新价一样，避免retailer待下单显示红字()
        // e['unitPriceBeforeDiscount'] = Number(e['unitPrice'])
        // end

        this.totalInfo.totalPriceProductDicounted += (Number(e['unitPriceBeforeDiscount']) - Number(e['unitPrice'])) * Number(e['num'])
        goodsNum += Number(e['num'])
      })

      this.totalInfo['subTotal'] = Number(this.totalInfo['cifSubTotal']) - Number(this.totalInfo['totalPriceProductDicounted']) - Number(this.totalInfo['totalPriceOrderDiscounted']) - Number(this.totalInfo['totalPriceOrderDiscountedShopvidi'])
      //如果为自营
      if(this.supplierManagementModel==2){
        if(this.tsStoreOrderInfo['type']==7){
          this.totalInfo['totalPriceOrderDiscounted'] = this.totalInfo['sourcePriceTotal']
        }
        this.totalInfo['subTotal'] = Number(this.totalInfo['sourcePriceTotal']) - Number(this.totalInfo['totalPriceProductDicounted']) - Number(this.totalInfo['totalPriceOrderDiscounted']) - Number(this.totalInfo['totalPriceOrderDiscountedShopvidi'])
      }


      this.totalInfo['payAmount'] = this.totalInfo['subTotal'] + Number(this.totalInfo['totalFreight'])

      // 修改用
      this.tsStoreOrderInfo['goodsNum'] = goodsNum
      // modify by cpgu 2023/03/23 为了和retailer兼容，totalPriceBefore采用后续的值 begin
      this.tsStoreOrderInfo['totalPriceBefore'] = this.totalInfo.cifSubTotal
      // this.tsStoreOrderInfo['totalPriceBefore'] = this.tsStoreOrderInfo.totalPriceBefore
      // end by cpgu

      this.tsStoreOrderInfo['productDiscounted'] = this.totalInfo.totalPriceProductDicounted
      this.tsStoreOrderInfo['orderDiscounted'] = this.totalInfo.totalPriceOrderDiscounted
      this.tsStoreOrderInfo['couponPrice'] = this.totalInfo.totalPriceOrderDiscountedShopvidi
      this.tsStoreOrderInfo['totalFreightBefore'] = this.totalInfo.totalFreightBefore
      this.tsStoreOrderInfo['freightDiscounted'] = this.totalInfo.totalFreightDiscounted
      this.tsStoreOrderInfo['totalFreight'] = Number(this.totalInfo.totalFreightBefore) - Number(this.totalInfo.totalFreightDiscounted)
      this.tsStoreOrderInfo['payAmount'] = this.totalInfo.payAmount
    },
    editOrder() {
      // add by cpgu 2023/03/29 重复赋值unit_price、单价 begin
      if (this.skuList && this.skuList.length > 0) {
        this.skuList.map((itm, i) => {
          if (!itm['db_isSkuChangePrice']) {
            // itm['unitPrice'] = itm['fobPriceFinal']
            itm['commodityAmount'] = Number(itm['unitPrice']) * Number(itm['num'])
          }
        })
      }
      // end by cpgu

      let params = {
        'tsStoreOrderInfo': this.tsStoreOrderInfo,
        'tsStoreOrderDetailList': this.skuList,
        'removeOrderDetailIds': this.removeOrderDetailIds,
        'tsStoreOrderAddress': this.tsStoreOrderAddress
      }
      putAction(`/sp/suppliers/retailers/orders/${this.orderId}`, params).then((res) => {
        if (res.success) {
          console.log(res, '提交修改')
          this.successVisible = true
          this.countdown()
          /**
           * SV-1.4.19 预生成PDF
           */
          postAction('/v0.2/invoices/batch_no/pdf?batchId=' + this.tsStoreOrderInfo.batchNo).then(response => {
            if (response.success) {

            } else {
              this.$message.warning(response.message)
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    countdown() {
      if (this.seconds === 0) {
        this.backOrderList()
      } else {
        this.seconds--
        this.timer = setTimeout(this.countdown, 1000)
      }
    },
    backOrderList() {
      clearTimeout(this.timer)
      this.successVisible = false
      this.$router.push({path: 'Order'})
    }

  }
}
</script>

<style lang="less" scoped>
.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 10px;
}

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
}

.border_box {
  width: 80%;
  height: auto;
  padding: 20px;
  border: 1px solid #dcdfe6;
  margin: 10px 0 15px 10%;

  .copy_title {
    font-size: 13px;
    font-family: Graphik;
    font-weight: 500;
    line-height: 28px;
    color: #262b2f;
  }

  .copy_subtitle {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    color: #5d5d5d;
  }
}

.confirm_button {
  background-color: #262b2f !important;
  border-color: #262B2F !important;
}

.back_button {
  background-color: #262b2f !important;
  border-color: #262B2F !important;
  margin-bottom: 15px;
  width: 140px;
}

.price_input {
  width: 80px;
  height: 40px;
}

.orange_background {
  width: 146px !important;
  background: #fb541c !important;
  border-color: #fb541c !important;
}

.page_button {
  display: flex;
  align-items: center;
}

.order_footer {
  width: 96%;
  display: flex;
  padding-left: 20px;
  margin-top: 38px;

  .footer_title {
    width: 50%;
    font-size: 16px;
    font-family: Avenir;
    font-weight: 800;
    line-height: 22px;
    color: #262B2F;

    .footer_subtitle {
      color: #262B2F;
      font-weight: 500;

    }
  }
}

.order_main {
  width: 96%;
  margin: 0px 0 0 20px;
}

.order_head_title {
  justify-content: space-between;
  padding-right: 50px;

  .order_num {
    margin-left: 30px;
  }
}

.prduct_box {
  display: flex;
  .product_img {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    max-width: 100px;
    max-height: 100px;
    object-fit: cover ;
    border: 1px solid #e1e1e1;
  }

  .product_info {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 20px;
    color: #262b2f;
    padding: 12px 0 0 12px;
    position: relative;

  }

  .dis_price {
    margin-left: 10px;
  }

  .dis_line {
    text-decoration: line-through;
  }
}

.order_nav {
  width: 96%;
  height: 140px;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin-left: 20px;

  .no_border {
    border: none !important;
  }

  .address_width {
    width: auto !important;
    max-width: 40%;

    .nac_msg_num {
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      padding-right: 20px;
      line-height: 18px !important;
    }
  }

  .nav_msg {
    flex-direction: column;
    padding: 20px 0 0 30px;
    width: 12%;
    height: 100%;

    .nac_msg_name {
      color: #5d5d5d;
      border-right: solid 1px #e1e1e1;
    }

    .nac_msg_num {
      padding-top: 10px;
      line-height: 24px;
      color: #262b2f;
      font-size: 14px;
      font-family: Graphik;
      font-weight: 400;
      border-right: solid 1px #e1e1e1;
    }

    .el-dropdown {
      margin-top: 10px;
      width: 80px;
    }

    .el-dropdown-link {
      color: #fff;
    }
  }
}

.gery_color {
  color: #8f8f8f;
  cursor: pointer;
}

.creat_button {
  width: 146px;
  height: 40px;
  background: #262b2f;
  border: 1px solid #262b2f;
  opacity: 1;
  border-radius: 3px;
  outline: none;
  color: #fff;
  font-size: 14px;
}

.add-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 192px;
  height: 38px;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
}

.end_box {
  width: 85%;
  margin-left: 30px;
  padding-bottom: 50px;
  flex-direction: column;
  align-items: flex-end;

  .creat_text {
    width: 45%;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
  }

  .blod_text {
    font-size: 16px;
    font-family: Graphik;
    font-weight: 500;
    color: #262b2f;
  }

  .split {
    border-bottom: 1px solid #E1E1E1;
    width: 100%;
  }
}

.brown_text {
  color: #c3824b;
}

.amount_text {
  color: #FB541C;
}

.memo {
  cursor: pointer;
  padding-top: 20px;

  span {
    padding-left: 10px;
    font-size: 16px;
    font-family: Avenir;
    font-weight: 500;
    line-height: 22px;
    color: #5D5D5D;
  }
}

.total_amount {
  justify-content: space-between;
  padding-right: 10px;

  .order-delete {
    cursor: pointer;
    font-size: 16px;
  }
}

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
  cursor: pointer;
}

.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 10px;
}

.back_button {
  width: 164px;
  height: 41px;
  border: 1px solid #707070;
  border-radius: 3px;
  margin: 30px 0;
}

.action_button {
  background: #000000;
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  padding: 0 10px !important;

}

.required-error,.mark-error {
  font-size: 12px;
  color: #F77073;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
}

.required-error {
  position: absolute;
  z-index: 99;
  white-space: nowrap;
  left: 120px;
  top: 100px;
}
.order_tracking_information{
  width: 96%;
  background: #FFFFFF;
  border:1px solid #e1e1e1;
  border-radius: 5px;
  margin-left: 20px;
  .order_tracking_information_header{
    height: 58px;
    border-radius: 5px;
    background-color: #F7F7F7;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .order_tracking_information_header_action{
      width: 159px;
      height: 40px;
      border-radius: 5px;
      background: #262B2F;
      color: #FFFFFF;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  .order_tracking_information_main{
    height: 69px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    color: #5D5D5D;
    .order_tracking_information_main_tracknumber,.order_tracking_information_main_carrier,.order_tracking_information_main_invoice{
      margin-left: 26px;
      font-family: Satoshi-Medium !important;
      span{
        margin-left: 20px;
        color: #262B2F;
      }
    }
    .order_tracking_information_main_invoice{
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.el-divider--horizontal{
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderDetail.vue